<style lang="scss">
  .mdm-setup {

  }
</style>

<template>
  <!-- Error page-->
  <div>
    <div v-if="loading" class="d-flex text-center flex-column justify-center align-center mt-5">
      <b-spinner variant="primary" />
    </div>

    <h4 v-else class="text-center mt-3 mx-4">You do not have valid access to this app</h4>
  </div>
<!-- / Error page-->
</template>

<script>
// import MagazineService from '@/services/magazineService';

export default {
  components: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {},
  mounted() {
    // listen for a custom electron event
    window.addEventListener('electronSetup', () => {
      console.log('called electron setup!');
      this.$store.commit('SET_IS_ELECTRON', true);
      this.$router.push({ name: 'dashboard' });
    });
  },
}
</script>
